import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PasoActividadPlanPayload {
  id_plan: number;
  paso: number;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface PasoActividadPlan {
  id?: number;
  id_plan: number;
  paso: number;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface PasoActividadPlanResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PasoActividadPlanService {
  private readonly apiUrl = `${environment.apiUrl}/api/pasos_actividad_plan`;

  constructor(private http: HttpClient) {}

  // Listar todos los pasos de actividad plan
  getAll(): Observable<PasoActividadPlan[]> {
    return this.http.get<PasoActividadPlan[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<PasoActividadPlan> {
    return this.http.get<PasoActividadPlan>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nuevo paso de actividad plan
  create(payload: PasoActividadPlanPayload): Observable<PasoActividadPlanResponse> {
    return this.http.post<PasoActividadPlanResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar paso de actividad plan
  update(id: number, payload: Partial<PasoActividadPlanPayload>): Observable<PasoActividadPlanResponse> {
    return this.http.put<PasoActividadPlanResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar paso de actividad plan (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar paso de actividad plan
  inactivar(id: number): Observable<PasoActividadPlanResponse> {
    return this.http.put<PasoActividadPlanResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar paso de actividad plan
  activar(id: number): Observable<PasoActividadPlanResponse> {
    return this.http.put<PasoActividadPlanResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}